const getRoleRedirectPath = (role) => {
  switch (role) {
    case 'admin':
    case 'marketAdmin':
    case 'countryAdmin':
      return '/admin/main';
    case 'translator':
    case 'reviewer':
      return '/admin/main/library';
    case 'countryManager':
      return '/admin/main';
    case 'superAdmin':
      return '/super-admin/main';
    case 'retailer':
    case 'retailerGM':
      return '/retailer/main';
    case 'hac':
      return '/hac/main';
    case 'pma':
    case 'pmaGM':
      return '/pma/calendar';
    case 'shippingAdmin':
      return '/shipping-admin/main';
    default:
      return '/login';
  }
};

export default getRoleRedirectPath;
